<template>
  <el-container class="avue-contail">
    <el-header height="auto" class="avue-header">
      <!-- 顶部导航栏 -->
      <top class="avue-top"/>
    </el-header>
    <el-container class="avue-layout">
      <div class="sidebar-mask" v-if="isMobile && !isCollapse" @click="handleChange"></div>
      <el-aside class="avue-left" :class="{ 'is-collapse': isCollapse }">
        <!-- 左侧导航栏 -->
        <el-scrollbar style="height:100%">
          <sidebar class="avue-sidebar"></sidebar>
        </el-scrollbar>
      </el-aside>
      <el-main class="avue-main">
        <!-- 顶部标签卡 -->
        <tags @closeSildebar="handleChange"  />
        <!-- 主体视图层 -->
        <el-scrollbar style="height:100%" ref="mainScrollbar">
          <keep-alive>
            <router-view class="avue-view" v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view class="avue-view" v-if="!$route.meta.keepAlive" />
        </el-scrollbar>
      </el-main>
    </el-container>
    <el-footer class="avue-footer">
      <p class="copyright">© 2017-{{nowYear}}成都聚家科技有限公司</p>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import tags from "./tags";
import top from "./top/";
import sidebar from "./sidebar/";
import { validatenull } from "@/util/validate";
import { calcDate } from "@/util/date.js";
import { getStore } from "@/util/store.js";
export default {
  components: {
    top,
    tags,
    sidebar,
  },
  name: "index",
  data() {
    return {
      //刷新token锁
      refreshLock: true,
      //刷新token的时间
      refreshTime: "",
      imInitData: {},
      tokenData: {},
      nowYear: new Date().getFullYear(),
      // 页面滚动位置缓存 { routePath: scrollTop }
      scrollPositionCache: {},
      // 移动端状态
      isMobile: false,
    };
  },
  created() {
    //实时检测刷新token
    this.refreshToken();
    this.$store.dispatch("setDsrms");
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  computed: mapGetters(["isLock", "isCollapse", "website"]),
  props: [],
  watch: {
    $route(to, from) {
      // 移动端路由切换时自动关闭侧边栏
      if (this.isMobile && !this.isCollapse) {
        this.$store.commit("SET_COLLAPSE", true);
      }
      // 离开页面时保存滚动位置
      if (from.meta.keepAlive) {
        const scrollWrap = this.getScrollWrap();
        if (scrollWrap) {
          this.scrollPositionCache[from.fullPath] = scrollWrap.scrollTop;
        }
      }
      // 进入页面时恢复滚动位置
      if (to.meta.keepAlive) {
        // 需要等待DOM完全渲染后再恢复滚动位置
        this.$nextTick(() => {
          setTimeout(() => {
            const scrollWrap = this.getScrollWrap();
            const savedPos = this.scrollPositionCache[to.fullPath];
            if (scrollWrap && savedPos !== undefined) {
              scrollWrap.scrollTop = savedPos;
            }
          }, 50);
        });
      }
    },
  },
  methods: {
    // 获取主滚动容器的实际DOM元素
    getScrollWrap() {
      const scrollbar = this.$refs.mainScrollbar;
      if (!scrollbar) return null;
      // 兼容Element UI不同版本的访问方式
      if (scrollbar.$refs && scrollbar.$refs.wrap) {
        return scrollbar.$refs.wrap;
      }
      // fallback: 直接查询DOM
      if (scrollbar.$el) {
        return scrollbar.$el.querySelector('.el-scrollbar__wrap');
      }
      return null;
    },
    handleChange() {
      // 控制左侧菜单栏的显示隐藏
      this.$store.commit("SET_COLLAPSE");
    },
    // 检测是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
      if (this.isMobile && !this.isCollapse) {
        this.$store.commit("SET_COLLAPSE", true);
      }
    },
    // 实时检测刷新token
    refreshToken() {
      this.refreshTime = setInterval(() => {
        const token = getStore({
          name: "token",
          debug: true,
        });
        const date = calcDate(token.datetime, new Date().getTime());
        if (validatenull(date)) return;
        if (!(date.seconds >= this.website.tokenTime) && !this.refreshLock) {
          this.refreshLock = true;
          this.$store
            .dispatch("RefeshToken")
            .then(() => {
              clearInterval(this.refreshTime);
            })
            .catch(() => {
              this.refreshLock = false;
            });
        }
      }, 3000);
    },
  },
};
</script>
<style lang="scss" scoped>
.avue-contail {
  width: 100%;
  height: 100%;
  background-color: $color-bg-page;
  background-size: 100%;
  background-repeat: no-repeat;
}
footer {
  height: $footer-height !important;
}
.avue-layout,
.avue-top {
  min-width: $layout-min-width;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.avue-left {
  width: $sidebar-width !important;
  min-width: 0 !important;
  transition: width $transition-base !important;
  overflow: hidden;
  flex-shrink: 0;
  .el-scrollbar {
    transition: opacity 0.2s ease;
  }
  &.is-collapse {
    width: $sidebar-collapse-width !important;
    .el-scrollbar {
      opacity: 0;
      pointer-events: none;
    }
  }
}
.avue-sidebar {
  height: 100%;
}
.avue-header {
  background: $color-bg-container;
  min-width: $layout-min-width;
  box-shadow: $shadow-header;
  margin-bottom: $spacing-sm;
}
.avue-main {
  padding: 0;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.avue-view {
  padding-bottom: $spacing-lg;
  width: 100%;
  box-sizing: border-box;
}
.avue-footer {
  margin: 0 auto;
  padding: 0 $spacing-lg;
  width: 100%;
  max-width: 1920px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    margin-left: -50px;
  }
  .copyright {
    color: $color-text-secondary;
    line-height: 1.5;
    font-size: $font-size-xs;
  }
}
// === 移动端适配 ===
@include mobile {
  .avue-layout,
  .avue-top,
  .avue-header {
    min-width: 100% !important;
    width: 100% !important;
  }
  .avue-left {
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 1001;
    height: 100vh !important;
    width: $sidebar-drawer-width !important;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
    background: $color-bg-container;
    transition: transform $transition-base !important;
    &.is-collapse {
      transform: translateX(-100%);
      width: $sidebar-drawer-width !important;
      .el-scrollbar {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
  .sidebar-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1000;
  }
  .avue-main {
    width: 100%;
  }
}
</style>
